import { useTranslation } from 'react-i18next';
import { useBranding } from '~/lib/branding';
import Button from './ui/Button';
import Card from './ui/Card';
import Icon from './ui/Icon';

function ErrorPage() {
  const { t } = useTranslation('', { keyPrefix: 'error' });
  const branding = useBranding();

  return (
    <div className="flex flex-col items-center justify-center h-dvh">
      <Card className="p-16 flex-col gap-8 items-center" outerClassName="w-full max-w-[800px]">
        <Icon name={branding === 'hero' ? 'errorPageHero' : 'errorPageChatoshi'} />
        <h1 className="text-4xl text-center">{t('title')}</h1>
        <p className="max-w-[400px] text-center text-body">{t('description')}</p>
        <Button className="w-[200px]" onPress={() => window.location.reload()}>
          {t('reload')}
        </Button>
      </Card>
    </div>
  );
}

export default ErrorPage;
